import { Button, Modal, Spacer } from '@ontruck/orc';
import PropTypes from 'prop-types';
import AssignAgentSelector from '../../../journey/AssignAgentSelector';
import React, { useCallback, useState } from 'react';

const t = {
  title: 'Assign agent to the itinerary',
  submit: 'Assign agent',
};

const AssignAgent = ({ onSelected, onClosed }) => {
  const [selectedAgent, setSelectedAgent] = useState();

  const onSelect = (option) => {
    setSelectedAgent(option?.agent);
  };

  const onClose = () => {
    onClosed();
  };

  const onSubmit = useCallback(() => {
    onSelected(selectedAgent);
  }, [onSelected, selectedAgent]);

  return (
    <Modal show size="S" headerComponent={t.title} onClose={onClose}>
      <Spacer mBottom="S" data-testid="assign-agent">
        <AssignAgentSelector onChange={onSelect} value={selectedAgent} />
      </Spacer>
      <Button
        data-testid="assign-agent-btn"
        disabled={!selectedAgent}
        text={t.submit}
        fullWidth
        onClick={onSubmit}
      />
    </Modal>
  );
};

AssignAgent.propTypes = {
  onSelected: PropTypes.func.isRequired,
  onClosed: PropTypes.func.isRequired,
};

export default AssignAgent;
